import { Link } from '@tanstack/react-router'
import React from 'react'
import styled from 'styled-components'

const StyledPage = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.forecast.background3};
`

const StyledTextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`

export const NoMatch: React.FC = () => (
  <StyledPage>
    <StyledTextContainer>
      <h1>Page Not Found</h1>
      <p>
        Return to the <Link to='/'>landing page?</Link>
      </p>
    </StyledTextContainer>
  </StyledPage>
)
